import script from "./XPage.vue?vue&type=script&setup=true&lang=js"
export * from "./XPage.vue?vue&type=script&setup=true&lang=js"

import "./XPage.vue?vue&type=style&index=0&id=5b975774&lang=scss&scoped=true"
import "./XPage.vue?vue&type=style&index=1&id=5b975774&lang=css"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b975774"]])

export default __exports__